import { useMutation } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { getCommentReplies } from '@/services/comment.service';
import { ToastVariant } from '@/components/ui/toast';
import { useToast } from '@/components/ui/use-toast';
import { useTranslations } from 'next-intl';

export const useFetchCommentRepliesMutation = () => {
  const tCommon = useTranslations('common');
  const tErrors = useTranslations('errors');

  const { toast } = useToast();

  const getCommentRepliesWithAuth = useAuthenticatedQueryFn(getCommentReplies);

  const fetchCommentRepliesMutation = useMutation({
    mutationFn: async ({
      commentId,
      limit,
      offset,
      shareId,
    }: {
      commentId: string;
      limit: number;
      offset: number;
      shareId?: string;
    }) => {
      const response = await getCommentRepliesWithAuth({
        commentId,
        limit,
        offset,
        shareId,
      });

      return {
        replies: response.comments,
        offset,
      };
    },
    onError: (error: { message?: string }) => {
      toast({
        variant: ToastVariant.DESTRUCTIVE,
        title: tCommon('error'),
        description: error?.message ?? tErrors('toastDefaultDescription'),
      });
    },
  });

  return {
    fetchCommentRepliesMutation,
  };
};
